import ToggleItem from './toggle_item';

export default class PageMargin extends ToggleItem {
  constructor() {
    super('pagemargin');
  }
}
